import React from 'react';
import PropTypes from 'prop-types';

import LoadScript from '../../../../../../../shared/components/LoadScript/LoadScript';
import reportException from '../../../../../../../shared/lib/report-exception';

export default class RBICookiePolicyComponent extends React.Component {
  static propTypes = {
    onUnmount: PropTypes.func,
  };

  componentWillUnmount() {
    if (document.body.onclick === this.onUnmount) {
      document.body.onclick = null;
    }
  }

  onUnmount = () => {
    const unmount = this.props.onUnmount;
    try {
      const banner = document.getElementById('rbiCookiePolicy_pushDownBoxWrapper');
      banner && banner.parentNode && banner.parentNode.removeChild(banner);

      // remove listeners, if any
      const closeBtnHolder = document.getElementById('rbiCookiePolicy_mainInformation');
      if (closeBtnHolder && closeBtnHolder.onclick) {
        closeBtnHolder.onclick = null;
      }
      if (document && document.body && document.body.onclick) {
        document.body.onclick = null;
      }

      unmount && unmount();
    } catch (err) {
      // report error removing element to sentry
      reportException(err, {}, 'rbi-cookie-component-unmounting');
    }
  };

  onCreate = () => {
    try {
      const closeBtnHolder = document.getElementById('rbiCookiePolicy_mainInformation');
      if (closeBtnHolder && !closeBtnHolder.onclick) {
        // may not appear if cookie policy has already been accepted
        closeBtnHolder.onclick = this.onUnmount;
      }

      if (document && document.onclick) {
        const cb = document.onclick;
        document.addEventListener('click', cb, true); // useCapture to true
      }

      const body = document.body;
      if (body && !body.onclick) {
        body.onclick = this.onUnmount;
      }

      const cookieNode = document.getElementById('rbiCookiePolicy_mainInformation');
      if (cookieNode) {
        cookieNode.children[1].innerHTML = [
          'Our website uses cookies, which are small text files that are widely used in order to make',
          'websites work more effectively. To continue using our website and consent to the use of',
          'cookies, click away from this box or click \'Close\'',
        ].join(' ');
      }
    } catch (err) {
      reportException(err, {}, 'rbi-cookie-component-on-create');
    }
  };

  render() {
    return (
      <LoadScript
        async
        url='https://static.flightstats.com/public/wordpress/rbi-cookie/rbi-cookie-component.js'
        onCreate={this.onCreate}
        onUnmount={this.onUnmount}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/EUCompliance/children/RBICookiePolicyComponent/RBICookiePolicyComponent.js